<span
  placement="right"
  tt_datatestid="label-tooltip"
  tt_datapendoid="label-tooltip"
  tt_arialabel="Label tooltip"
  rw-tooltip="{{ tooltip }}"
  class="{{ cssClass }}"
  >{{ truncatedVal }}</span
>
